<template>
  <e-sidebar
    id="sidebar-estimate"
    ref="sidebar"
    :title="$t('Dados da entrega')"
    :show="showSidebar"
    :fetching="fetching"
    :saving="saving"
    :confirm-button-text="$t('Reiniciar entrega')"
    :cancel-button-text="$t('Fechar')"
    :extra-buttons="
      [
        {
          event: 'cancelDelivery',
          variant: 'danger',
          text: $t('Cancelar entrega'),
          icon: 'x-circle',
          hide:
            !order.deliveryOrder ||
            order.deliveryOrder.status === 'canceled' ||
            order.deliveryOrder.status === 'delivered',
        },
      ].filter((btn) => !btn.hide)
    "
    width="40%"
    @hidden="hide"
    @save="restartDelivery"
    @cancelDelivery="cancelDelivery"
  >
    <template
      v-if="order.deliveryOrder || selectedDispatch"
      #content
    >
      <b-row v-if="order">
        <b-col>
          <FormulateInput
            :value="`#${order.id} - ${order.customer.name}`"
            type="label"
            :label="$t('Pedido')"
          />
          <template v-if="!order.deliveryOrder && selectedDispatch">
            <FormulateInput
              :value="selectedDispatch.supplierName || '-'"
              type="label"
              :label="$t('Serviço de entrega')"
            />
            <FormulateInput
              :value="selectedDispatch.statusLabel || '-'"
              type="label"
              :label="$t('Status da entrega')"
            />
            <FormulateInput
              v-if="selectedDispatch.supplierOrderId"
              :value="selectedDispatch.supplierOrderId"
              type="label"
              :label="$t('Id do pedido de entrega')"
            />
            <FormulateInput
              :value="pickupAddressLabel"
              type="label"
              :label="$t('Local de retirada')"
            />
            <FormulateInput
              :value="deliveryAddressLabel"
              type="label"
              :label="$t('Local de entrega')"
            />
          </template>
          <template v-else>
            <FormulateInput
              v-model="order.deliveryOrderId"
              type="label"
              :label="$t('Id do pedido de entrega')"
            />
            <FormulateInput
              :value="order.deliverySupplier ? order.deliverySupplier.name : '-'"
              type="label"
              :label="$t('Serviço de entrega')"
            />
            <FormulateInput
              :value="$t(`PAY_BOX_SALE.DELIVERY_STATUS.${order.deliveryOrder.status}`)"
              type="label"
              :label="$t('Status da entrega')"
            />
            <FormulateInput
              v-if="order.deliveryOrder.driverInfo && order.deliveryOrder.driverInfo.vehicleInfo"
              :value="`${order.deliveryOrder.driverInfo.name} - ${$t('Placa/Cor')}: ${
                order.deliveryOrder.driverInfo.vehicleInfo.plateNo
              } / ${order.deliveryOrder.driverInfo.vehicleInfo.color} - ${$t(
                'Telefone'
              )}: ${$options.filters.phone(order.deliveryOrder.driverInfo.phone)}`"
              type="label"
              :label="$t('Dados do entregador')"
            />
            <FormulateInput
              :value="pickupVerifyCodeLabel"
              type="label"
              :icons="pickupVerifyCodeIcons"
              :label="$t('Código de verificação para o motorista')"
              :instruction="
                $t(
                  'Código de verificação que o motorista deverá fornecer à loja no momento da retirada dos produtos'
                )
              "
              @toggle-pickup-verify-code="showPickupVerifyCode = !showPickupVerifyCode"
            />
            <FormulateInput
              :value="dropoffVerifyCodeLabel"
              type="label"
              :icons="dropoffVerifyCodeIcons"
              :label="$t('Código de verificação para o cliente')"
              :instruction="
                $t(
                  'Código de verificação que o cliente deverá fornecer ao entregador no momento da entrega'
                )
              "
              @toggle-dropoff-verify-code="showDropoffVerifyCode = !showDropoffVerifyCode"
            />
            <FormulateInput
              v-if="order.deliveryOrder.verifyInfo && order.deliveryOrder.verifyInfo.returnVerifyCode"
              :value="
                order.deliveryOrder.verifyInfo
                  ? order.deliveryOrder.verifyInfo.returnVerifyCode
                  : '-'
              "
              type="label"
              :label="$t('Código de verificação para devolução')"
              :instruction="
                $t(
                  'Código de verificação que a loja deverá fornecer ao entregador no momento da devolução'
                )
              "
            />
            <FormulateInput
              :value="lastEstimateLabel"
              type="label"
              :label="$t('Distância / Tempo de entrega')"
            />
            <FormulateInput
              :value="`${store.address.publicPlace}, ${store.address.number} - ${store.address.neighborhood}`"
              type="label"
              :label="$t('Local de retirada')"
            />
            <FormulateInput
              :value="`${order.deliveryAddress.publicPlace}, ${order.deliveryAddress.number} - ${order.deliveryAddress.neighborhood}`"
              type="label"
              :label="$t('Local de entrega')"
            />
          </template>
        </b-col>
      </b-row>
    </template>
  </e-sidebar>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { BCol, BRow } from 'bootstrap-vue'
import ESidebar from '@/views/components/ESidebar.vue'

export default {
  components: { ESidebar, BCol, BRow },

  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showSidebar: false,
      fetching: false,
      saving: false,
      selectedDispatch: null,
      showPickupVerifyCode: false,
      showDropoffVerifyCode: false,
    }
  },

  computed: {
    ...mapState('app', ['stores']),
    ...mapState('pages/sale/deliveryDashboard', ['filter']),
    // ...mapState('auth', ['userData']),
    store() {
      // eslint-disable-next-line eqeqeq
      return this.stores.find(store => store.id == this.filter.storeId)
    },
    lastEstimateLabel() {
      const estimate = this.order?.lastDeliveryEstimate
      if (!estimate || estimate.distance == null || estimate.duration == null) return '-'
      return `${estimate.distance / 1000} km / ${estimate.duration} min`
    },
    pickupAddressLabel() {
      const address = this.store?.address
      return address
        ? `${address.publicPlace}, ${address.number} - ${address.neighborhood}`
        : '-'
    },
    deliveryAddressLabel() {
      const address = this.order?.deliveryAddress
      return address
        ? `${address.publicPlace}, ${address.number} - ${address.neighborhood}`
        : '-'
    },
    pickupVerifyCode() {
      return this.order?.deliveryOrder?.verifyInfo?.pickupVerifyCode || ''
    },
    dropoffVerifyCode() {
      return this.order?.deliveryOrder?.verifyInfo?.dropoffVerifyCode || ''
    },
    pickupVerifyCodeLabel() {
      return this.getVerifyCodeLabel(this.pickupVerifyCode, this.showPickupVerifyCode)
    },
    dropoffVerifyCodeLabel() {
      return this.getVerifyCodeLabel(this.dropoffVerifyCode, this.showDropoffVerifyCode)
    },
    pickupVerifyCodeIcons() {
      return this.getVerifyCodeIcons(
        this.pickupVerifyCode,
        this.showPickupVerifyCode,
        'toggle-pickup-verify-code'
      )
    },
    dropoffVerifyCodeIcons() {
      return this.getVerifyCodeIcons(
        this.dropoffVerifyCode,
        this.showDropoffVerifyCode,
        'toggle-dropoff-verify-code'
      )
    },
  },

  mounted() {},

  methods: {
    ...mapActions('pages/sale/deliveryDashboard', ['cancelDeliveryOrder']),
    async show(dispatch = null) {
      this.selectedDispatch = dispatch
      this.hideVerifyCodes()
      this.showSidebar = true
    },

    hide() {
      this.showSidebar = false
      this.selectedDispatch = null
      this.hideVerifyCodes()
    },

    hideVerifyCodes() {
      this.showPickupVerifyCode = false
      this.showDropoffVerifyCode = false
    },

    getVerifyCodeLabel(code, visible) {
      if (!code) return '-'
      return visible ? code : '•'.repeat(String(code).length)
    },

    getVerifyCodeIcons(code, visible, eventName) {
      if (!code) return []
      return [
        {
          eventName,
          icon: visible ? 'eye-slash-fill' : 'eye-fill',
          clazz: '',
          variant: '',
          title: visible ? this.$t('Ocultar código') : this.$t('Mostrar código'),
        },
      ]
    },

    restartDelivery() {
      this.$emit('restart-delivery', this.order)
      this.hide()
    },

    async cancelDelivery() {
      if (await this.confirm({ text: this.$t('Confirma o cancelamento da entrega?') })) {
        try {
          this.saving = true
          await this.cancelDeliveryOrder(this.order.id)
          this.$emit('cancel-delivery', this.order)
          this.hide()
          this.showSuccess({ message: this.$t('Entrega cancelada com sucesso.') })
        } catch (error) {
          this.showError({ error })
        } finally {
          this.saving = false
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.text-bold {
  font-weight: 800;
}
</style>
